export const PRIVACY_POLICY_CONTENT = `
## 1. Responsable del tratamiento

| Concepto | Dato |
| --- | --- |
| Responsable | Alejandro Serrano Notivoli |
| NIF | ES29133706C |
| Domicilio | C/ Felipe Sanclemente 8, 4B, 50001, Zaragoza, España |
| Correo electrónico | soporte@alejandrosn.com |
| Sitio web | https://alejandrosn.com |

## 2. Ámbito de aplicación

Esta Política de Privacidad se aplica al tratamiento de datos personales realizado a través del sitio web AlejandroSN (https://alejandrosn.com), incluyendo la navegación por el blog, las páginas informativas, la página de servicios y el contacto por formulario o correo electrónico.

Este sitio no requiere registro de usuario ni recopila datos de pago.

## 3. Datos que tratamos

Podemos tratar las siguientes categorías de datos:

- **Datos técnicos de navegación:** dirección IP, tipo de navegador, sistema operativo, páginas visitadas y tiempo de permanencia (solo si aceptas cookies analíticas). Si rechazas las cookies, Google puede recibir una señal sin identificadores de cookie para estimar el tráfico de forma agregada.
- **Datos de contacto:** nombre, dirección de correo electrónico, teléfono si lo indicas, tipo de proyecto y mensaje, cuando escribes a soporte@alejandrosn.com o envías el formulario de contacto o de servicios. Si llegas desde un anuncio, el mensaje puede incluir los parámetros de campaña (utm_source, utm_medium, utm_campaign y gclid).

No recopilamos categorías especiales de datos de forma intencionada.

## 4. Finalidades y base legal

| Finalidad | Base legal |
| --- | --- |
| Permitir la navegación y visualización del sitio | Interés legítimo (art. 6.1.f RGPD) |
| Mostrar el listado del blog a partir del feed público de Substack | Interés legítimo (art. 6.1.f RGPD) |
| Análisis estadístico del sitio (Google Analytics) | Consentimiento (art. 6.1.a RGPD) |
| Medición de anuncios (Google Ads: llamadas, reservas, formularios y emails) | Consentimiento (art. 6.1.a RGPD) |
| Responder consultas enviadas por formulario o correo electrónico | Interés legítimo / medidas precontractuales (art. 6.1.b y 6.1.f RGPD) |

## 5. Destinatarios y encargados del tratamiento

Tus datos pueden ser comunicados a los siguientes proveedores:

| Proveedor | Finalidad | Ubicación |
| --- | --- | --- |
| Cloudflare, Inc. | Hosting, CDN e imágenes | EE. UU. / UE (con garantías adecuadas) |
| Substack Inc. | Feed público de la newsletter (títulos, extractos y enlaces) | EE. UU. / UE (con garantías adecuadas) |
| Google LLC | Google Analytics y Google Ads (si consientes) y Google Fonts | EE. UU. / UE |

No vendemos ni cedemos tus datos a terceros con fines comerciales.

## 6. Transferencias internacionales

Algunos proveedores pueden tratar datos fuera del Espacio Económico Europeo. En esos casos, se aplican las garantías previstas en el RGPD (Cláusulas Contractuales Tipo de la Comisión Europea u otros mecanismos reconocidos).

## 7. Plazos de conservación

- **Datos analíticos y de medición publicitaria:** según la política de retención de Google (Analytics hasta 26 meses, configurable; cookies de Ads hasta 90 días).
- **Formularios y correos de contacto:** hasta 2 años desde la última comunicación, salvo obligación legal.
- **Logs técnicos de Cloudflare:** según la política de retención del proveedor (máximo 12 meses).

## 8. Derechos del interesado

Puedes ejercer los siguientes derechos dirigiéndote a soporte@alejandrosn.com:

- **Acceso** a tus datos personales.
- **Rectificación** de datos inexactos.
- **Supresión** («derecho al olvido»), cuando proceda.
- **Limitación** del tratamiento.
- **Portabilidad** de los datos que nos hayas facilitado.
- **Oposición** al tratamiento basado en interés legítimo.
- **Retirar el consentimiento** en cualquier momento (sin efectos retroactivos).

También tienes derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD): https://www.aepd.es

## 9. Seguridad

Aplicamos medidas técnicas y organizativas adecuadas para proteger los datos, incluyendo comunicaciones cifradas (HTTPS/TLS) e infraestructura en Cloudflare Edge.

## 10. Menores de edad

Este sitio no está dirigido a menores de 16 años. No recopilamos datos de menores de forma consciente.
`;
